package com.neurobs.ccabserver.administrator.contexts

import com.neurobs.ccabserver.administrator.controller.RecordCache
import com.neurobs.react.ContextBase

object RecordCacheContext extends ContextBase[RecordCache] {
	override protected def defaultStateValue(): RecordCache = new RecordCache
}
